import React from 'react';

import cn from 'classnames';

import { TAttachmentDTOCamelCased, TAttachmentOnClient } from '@entities/attachment/model/types';
import { Flex, Icon, UiButton, UiText } from '@shared/ui';

import cls from './UploadedFile.module.css';

interface UploadedFileProps {
    classes?: string;
    file?: TAttachmentOnClient | TAttachmentDTOCamelCased;
    onClickInputRef?: () => void;
}

export const UploadedFile = ({ classes, file, onClickInputRef }: UploadedFileProps) => {
    console.log('file', file);
    return (
        <Flex
            gap={8}
            direction="column"
            justify="center"
            className={cn(cls.UploadedFile, [classes])}
        >
            <Icon iconName="xlsIcon" />
            <UiText>{file?.file?.name || file?.name}</UiText>
            <UiButton variant="text" onClick={onClickInputRef} btnText="Заменить файл" />
        </Flex>
    );
};
